const includes=(array,value)=>-1!==array.indexOf(value);export{includes as default};
